<template>
  <div id="topLeft" class="content-box-item">
    <div class="top-top">
      <div class="outlet-name">
        <el-image class="title-bg" :src="require('@/assets/images/title-bg.png')" fit="fit"/>
        <span class="outlet-name-txt"></span>
      </div>
      <div class="outlet-desc">
        <span class="outlet-desc-title">{{cdata.title}}，欢迎登录</span>
        <div class="outlet-desc-con">
          <div class="outlet-desc-item-con">
            <span class="outlet-desc-item">门店ID: NO.{{cdata.id}}</span>
          </div>
          <div class="outlet-desc-item-con">
            <span class="outlet-desc-item">账号: {{account}}</span>
          </div>
          <div class="outlet-desc-item-con">
            <span class="outlet-desc-item">剩余短信: {{cdata.remVccCounts}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="top-bottom">
      <div class="outlet-data-item">
        <div class="outlet-data-item-top">
          <el-image :src="require('@/assets/icons/icon-1.png')" fit="fit"/>
          <span class="outlet-data-item-txt">本店会员</span>
        </div>
        <div class="outlet-data-item-bottom">
          <span class="outlet-data-item-value">总数：{{cdata.allVipCount}} 人</span>
        </div>
      </div>
      <div class="outlet-data-item">
        <div class="outlet-data-item-top">
          <el-image :src="require('@/assets/icons/icon-2.png')" fit="fit"/>
          <span class="outlet-data-item-txt">新增会员</span>
        </div>
        <div class="outlet-data-item-bottom">
          <span class="outlet-data-item-value">总数：{{cdata.newVipCount}} 人</span>
        </div>
      </div>
      <div class="outlet-data-item">
        <div class="outlet-data-item-top">
          <el-image :src="require('@/assets/icons/icon-3.png')" fit="fit"/>
          <span class="outlet-data-item-txt">不足30天会员</span>
        </div>
        <div class="outlet-data-item-bottom">
          <span class="outlet-data-item-value">总数：{{cdata.vip30DayCount}} 人</span>
        </div>
      </div>
      <div class="outlet-data-item">
        <div class="outlet-data-item-top">
          <el-image :src="require('@/assets/icons/icon-4.png')" fit="fit"/>
          <span class="outlet-data-item-txt">卡次不足10次</span>
        </div>
        <div class="outlet-data-item-bottom">
          <span class="outlet-data-item-value">总数：{{cdata.card10Count}}  人</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import globaldata from "@/utils/globaldata";

export default {
  data() {
    return {
      account:globaldata.getAdminStore().name
    }
  },
  //
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    },
  },
  watch: {
    cdata: {
      handler (newData) {

      },
      immediate: true,
      deep: true
    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
#topLeft {
  width: calc(100% - 20px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  .top-top{
    width: 94%;
    height: 45%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    border-bottom: 1px solid #ecf0f1;
  }
  .outlet-name{
    width:100px;
    height:100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  .title-bg{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
  }
  .outlet-name-txt{
    width: 100%;
    height: 100%;
    font-size: 24px;
    line-height: 100px;
    text-align: center;
    color: #0d6fb8;
    z-index: 9;
  }
  .outlet-desc{
    width: calc(100% - 105px);
    height:100px;
    margin-left: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: start;
  }
  .outlet-desc-title{
    width: 100%;
    height: 40px;
    font-size: 22px;
    line-height: 40px;
    text-align: left;
    color: #000000;
  }
  .outlet-desc-con{
    width: 100%;
    height: 60px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
  }
  .outlet-desc-item-con{
    width: auto;
    height: 40px;
    align-items: center;
    padding-left: 30px;
    padding-right: 30px;
    border-radius: 20px;
    margin-right: 15px;
    background: #f3f6fb;
    border: 1px solid #0d6fb8;
  }
  .outlet-desc-item{

    font-size: 16px;
    line-height: 40px;
    text-align: center;
    background-image:-webkit-linear-gradient(left,#0d6fb8, #63b1ff);
    -webkit-background-clip:text;
    -webkit-text-fill-color:transparent;

  }
  .top-bottom{
    width: 94%;
    height: 55%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #ecf0f1;
  }
  .outlet-data-item{
    width: 23%;
    height: 70%;
    background: #f6f7fb;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: start;
  }
  .outlet-data-item-top{
    width: 88%;
    height: 50%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
  }
  .outlet-data-item-txt{
    margin-left: 20px;
    font-size: 18px;
    line-height: 30px;
    text-align: center;
    color: #000000;
  }
  .outlet-data-item-bottom{
    width: 88%;
    height: 50%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
  }
  .outlet-data-item-value{
    width: 100%;
    font-size: 18px;
    line-height: 30px;
    text-align: left;
    background-image:-webkit-linear-gradient(left,#0d6fb8, #a5d7ff);
    -webkit-background-clip:text;
    -webkit-text-fill-color:transparent;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/data/top/topLeft.vue